module.exports = __webpack_public_path__ + "static/media/bg4.08df4125.jpg";